import { Grammar, Parser } from 'nearley';

import { stringToOperator } from '../../mappers/filter/filter';
import {
    FilterExpressionValueType,
    FilterPartialExpression,
    Operator,
    ParsedFilterPartialExpression
} from '../../typings/filter';
import { castStringToEnum } from '../CastHelpers';

import * as grammar from './grammar';

const parser = new Parser(Grammar.fromCompiled(grammar));
const initialState = parser.save();

const calcExpressionWeight = (expr: FilterPartialExpression): number => {
    return ['field', 'additionalField', 'separatorField', 'operator', 'value'].reduce((expressionWeight, key) => {
        return expressionWeight + (expr[key] !== undefined && expr[key] !== '' ? 1 : 0);
    }, 0);
};

export function parse(str: string): ParsedFilterPartialExpression[] {
    return str
        .split('|')
        .filter(part => part.trim() !== '')
        .map(parseExpression);
}

function parseExpression(str: string): ParsedFilterPartialExpression {
    parser.feed(str);
    const expressions = parser.finish();
    parser.restore(initialState);

    if (expressions.length === 0) {
        return {
            field: ''
        };
    }

    const resultExpression = expressions.reduce(
        (res, item) => {
            const weight = calcExpressionWeight(item);

            const itemHaveHeavierField =
                item.field !== undefined && res.item.field !== undefined && item.field.length > res.item.field.length;

            const itemHaveHeavierOperator =
                item.operator !== undefined &&
                res.item.operator !== undefined &&
                item.operator.length > res.item.operator.length;

            /**
             * "Название >=" может распарситься как { field: 'Название ', operator: '>=' } и как { field: 'Название', operator: '>=' }
             * Название поле с пробелом - правильный вариант только для случая, когда нет оператора
             * (по этому признаку вычисляется suggestStep)
             */
            const needToReplace =
                weight > res.weight ||
                (weight === res.weight && (itemHaveHeavierOperator || (!item.operator && itemHaveHeavierField)));

            return needToReplace
                ? {
                      weight,
                      item
                  }
                : res;
        },
        {
            weight: -1,
            item: {}
        }
    ).item;

    return {
        field: resultExpression.field,
        separatorField: resultExpression.separatorField,
        additionalField: resultExpression.additionalField,
        operator: resultExpression.operator
            ? castStringToEnum(stringToOperator(resultExpression.operator), Operator)
            : undefined,
        value:
            resultExpression.value === undefined
                ? undefined
                : {
                      type: FilterExpressionValueType.partial,
                      value: resultExpression.value
                  }
    } as ParsedFilterPartialExpression;
}
